import React, { useEffect, useState } from "react";
import { notification } from 'antd';
import { DescriptionText, FlexContainer, H1Text, H2Text, LeftBackButtonText, Button, Text } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import {
  addSubscriptionV2LinkPaymentMethod,
  findSubscriptionV2LinkById,
  BASE_URLS,
  getSecretValuesById,
  planUpdate,
} from "../../api";
import { MESSAGES, SWIREPAY_URL, TabNames, LPG_CUSTOMER } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./components/smallscreen/header";
import { AmountDivideByHundred } from "../../helper";
import Support from "../../components/support";
import SmallScreenFooter from "../../components/smallscreen/footer";
import currencyFormatter from "../../utils/currencyformatter";
import CardPayment from "../../components/cardpayment/CardPayment";
import PaymentMethodTabs from "../../components/paymentmethodtabs";
import getformatteddate from "../../utils/getformatteddate";
import getRedirectionUrl from "../../utils/getRedirectionUrl";
import getMenuTabs from "../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import AchPayment from "../../components/achPaymentWithPlaid";
import BankPayment from "../../components/bankpayment/BankPayment";
import UpiPayment from "../../components/upipayment/UpiPayment";
import Apple from '../../routes/apple';
import GooglePay from "../../components/googlePay/GooglePay";

type Props = {
  history: {
    push: Function,
  },
}

const PlanList = (props: Props) => {

  const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
  const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const [errorMessage, setErrorMessage] = useState();
  const [isShowSpinner, setShowSpinner] = useState(false);
  const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);
  const [account, setAccount] = useState(null);
  const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
  const [transactionModalBodyText, setTransactionModalBodyText] = useState(null);
  const [subscriptionId, setSubscriptionId] = useState('');
  const paymentSelected = sessionStorage.getItem('slectedPayment');
  const hostName = (window && window.location && window.location.host);
  const [ipAddress, setIpAddress] = useState('');
  const [upiDownTime, setUpiDownTime] = useState(false);
  const [gpaySecretValues, setGpaySecretValues] = useState(null);
  const [gpayError, setGpayError] = useState(null);
  const [payment, setPayment] = useState(null);
  const [applePayment, setApplePayment] = useState(false);
  const [isApplePay, setIsApplePay] = useState(false);
  const [link, setLink] = useState(SWIREPAY_URL);

  const { match: { params: { id } }, location: { pathname, search } } = props;
  const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${id}`) || undefined);

  const getData = async () => {
    const response = await fetch('https://api.ipify.org/?format=json');
    const data = await response.json();
    setIpAddress(data.ip);
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (search) {
      getSubscriptionLinkDataWithSearchValue();
    } else {
      getSubscriptionLinkDataWithoutSearchValue();
    }
  }, [id, search]);

  useState(() => {
    if (window.ApplePaySession && window.ApplePaySession.supportsVersion(14)) {
      setIsApplePay(true);
    }
  }, []);

  useEffect(() => {
    setSubscriptionId(subscription && subscription.gid);
    if (subscription && subscription.currency && subscription.currency.name) {
      let amount = currencyFormatter(1, subscription.currency && subscription.currency.name);
      if (subscription && subscription.paymentMethod && subscription.paymentMethod.bank) {
        setTransactionModalBodyText(`You will be redirected once verification is complete\n. As part of the verification process, you might see a temporary hold of ${amount} in your bank account.`)
      } else {
        setTransactionModalBodyText(`You will be redirected once verification is complete\n. As part of the verification, if using a debit or credit card you might see a temporary hold of ${amount}`)
      }
      
    }
  }, [subscription]);

  const getGooglePayMerchantValues = async (accountGid) => {
    try {
      const values = await getSecretValuesById(accountGid, null);
      setGpaySecretValues(values);
    } catch (error) {
      setGpayError('Missing merchant details. Please contact support');
    }
  };

  const addPaymentMethod = async (data) => {
    const { card, cvv, expiry, name } = data;
    const cardExpiry = expiry.split(" / ");
    const number = card.replace(/\s+/g, '');
    const paymentMethodBillingAddress = (account && account.collectBillingAddress) ? {city: data.billcity || null, countryCode : (data.country && data.country) || null, state: (data.billstate && (data.billstate === 'TG' ? 'TS' : (data.billstate === 'UT' ? 'UK' : (data.billstate === 'DH' ? 'DN' : data.billstate)))) || null,
        street: data?.billaddress ? (`${data.billaddress} ${data.billaddress1 || ''}`).trim() : null }
         : null;
    const postalCode =  (account && account.collectBillingAddress) ?  (data.zipCode || null) : null;
    const paymentMethodDetails = { type: "CARD", postalCode, paymentMethodBillingAddress, card: { cvv, name, number, expiryMonth: cardExpiry[0], expiryYear: cardExpiry[1] } };
    const userAgent = {
      acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8", 
      ip: ipAddress,
      language: window.navigator.language, 
      colorDepth: window.screen.colorDepth,
      screenHeight: window.screen.height, 
      screenWidth: window.screen.width,
      timeZone: new Date().getTimezoneOffset(), 
      browserUserAgent: window.navigator.userAgent
     };
     paymentMethodDetails.userAgent = userAgent;
     paymentMethodDetails.setAsDefault = true;

    try {
      const value = await addSubscriptionV2LinkPaymentMethod(id, paymentMethodDetails);
      if (value) {
        const { redirectUri, setupSession } = value;
        if (setupSession && setupSession.nextActionUrl) {
          window.location = setupSession.nextActionUrl;
          return;
        }
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        setTimeout(function () {
          const uri = getRedirectionUrl(hostName);
          if (redirectUri) {
            window.location = `${redirectUri}?sp-subscription-link=${id}`;
          } else if (uri) {
            window.location = `${uri}subscriptions/${subscriptionId}`;
          }
        }, 5000);
      }
    } catch (reason) {
      error(reason);
    }
  };

  const addACHMethod = async (data) => {
    const { paymentMethod } = data;
    try {
      const value = await addSubscriptionV2LinkPaymentMethod(id, paymentMethod);
      if (value) {
        const { redirectUri, setupSession } = value;
        if (setupSession && setupSession.nextActionUrl) {
          window.location = setupSession.nextActionUrl;
          return;
        }
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        setTimeout(function () {
          const uri = getRedirectionUrl(hostName);
          if (redirectUri) {
            window.location = `${redirectUri}&sp-subscription-link=${id}`;
          } else if (uri) {
            window.location = `${uri}subscriptions/${subscriptionId}`;
          }
        }, 5000);
      }
    } catch (reason) {
      error(reason);
    }
  };

  const addUPIMethod = async (data) => {
    const { paymentMethod } = data;
    try {
      const value = await addSubscriptionV2LinkPaymentMethod(id, paymentMethod);
      if (value) {
        const { redirectUri, setupSession } = value;
        if (setupSession && setupSession.nextActionUrl) {
          window.location = setupSession.nextActionUrl;
          return;
        }
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        setTimeout(function () {
          const uri = getRedirectionUrl(hostName);
          if (redirectUri) {
            window.location = `${redirectUri}&sp-subscription-link=${id}`;
          } else if (uri) {
            window.location = `${uri}subscriptions/${subscriptionId}`;
          }
        }, 5000);
      }
    } catch (reason) {
      error(reason);
    }
  };

  const addBankMethod = async (data) => {
    const { customerGid, fundingSourceId } = data;
    const payload = {
      bank: {
        referenceId: fundingSourceId,
      },
      customerGid,
      type: "ACH"
    };
    try {
      const value = await addSubscriptionV2LinkPaymentMethod(id, payload);
      if (value) {
        const { redirectUri, setupSession } = value;
        if (setupSession && setupSession.nextActionUrl) {
          window.location = setupSession.nextActionUrl;
          return;
        }
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        setTimeout(function () {
          const uri = getRedirectionUrl(hostName);
          if (redirectUri) {
            window.location = `${redirectUri}&sp-subscription-link=${id}`;
          } else if (uri) {
            window.location = `${uri}subscriptions/${subscriptionId}`;
          }
        }, 5000);
      }
    } catch (reason) {
      error(reason);
    }
  };

  const addGooglePayMethod = async (data) => {
    const paymentMethod = {
      type: "WALLET",
      subType: "GOOGLE_PAY_US",
      googlePayUS: {
        apiVersionMinor: data.apiVersionMinor,
        apiVersion: data.apiVersion,
        paymentMethodDescription: data.paymentMethodData.description,
        paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
        paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
        paymentMethodType: data.paymentMethodData.type,
        paymentMethodInfo: data.paymentMethodData.info
      },
    };
    try {
      const value = await addSubscriptionV2LinkPaymentMethod(id, paymentMethod);
      if (value) {
        const { redirectUri, setupSession } = value;
        if (setupSession && setupSession.nextActionUrl) {
          window.location = setupSession.nextActionUrl;
          return;
        }
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        setTimeout(function () {
          const uri = getRedirectionUrl(hostName);
          if (redirectUri) {
            window.location = `${redirectUri}&sp-subscription-link=${id}`;
          } else if (uri) {
            window.location = `${uri}subscriptions/${subscriptionId}`;
          }
        }, 5000);
      }
    } catch (reason) {
      error(reason);
    }
  };

  const addApplePayMethod = async (deviceData, amount, customerName, customerEmail,
                                   customerPhone, countryCode, stateCode, street, postalCode, city,
                                   cardNetwork, cardType, cardLast4) => {
    const paymentMethod = {
      applePayUS: {
        deviceData: deviceData,
        cardBrand: cardNetwork,
        cardFundingType: cardType,
        applePayDynamicLast4: cardLast4,
        cardLast4: cardLast4
      },
      type: "WALLET",
      subType: "APPLE_PAY_US",
      postalCode: postalCode,
      paymentMethodBillingAddress: {
        city: city,
        countryCode: countryCode,
        state: stateCode,
        street: street
      }
    }
    try {
      const value = await addSubscriptionV2LinkPaymentMethod(id, paymentMethod);
      if (value) {
        const { redirectUri, setupSession } = value;
        if (setupSession && setupSession.nextActionUrl) {
          window.location = setupSession.nextActionUrl;
          return;
        }
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        setTimeout(function () {
          const uri = getRedirectionUrl(hostName);
          if (redirectUri) {
            window.location = `${redirectUri}&sp-subscription-link=${id}`;
          } else if (uri) {
            window.location = `${uri}subscriptions/${subscriptionId}`;
          }
        }, 5000);
      }
    } catch (reason) {
      error(reason);
    }
  }

  const updatePlan = async (planId) => {
    try {
      const value = await planUpdate(planId, id);
      if (value) {
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        setTimeout(function () {
          window.location = payment?.link;
        }, 5000);
      }
    } catch (reason) {
      error(reason);
    }
  };

  const getSubscriptionLinkDataWithoutSearchValue = async () => {
    setShowSpinner(true);
    try {
      const value = await findSubscriptionV2LinkById(id, null);
      if (value) {
        setData(value);
        value.currency = value?.account?.currency;
        value.amount = value?.subscription2?.total ? value.subscription2.total : value?.subscription2?.amount;
        setPayment(value);
        // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
        //   const val = await getHealthCheck();
        //   if (val && val.status !== 'ACTIVE') {
        //     setUpiDownTime(true);
        //     notification.open({
        //         message: '',
        //         description: <img src={UPIIMAGE} alt="" />,
        //       });
        // }
        // }
      }
      setApplePayment(value?.account?.supportedRecurringPaymentTypes.includes('APPLE_PAY_US'));
      if ((value?.account?.supportedRecurringPaymentTypes).includes('GOOGLE_PAY_US') || (value?.account?.supportedRecurringPaymentTypes).includes('WALLET')) {
        await getGooglePayMerchantValues(value && value.account && value.account.gid);
      }
    } catch (e) {
      props.history.push(`${pathname}/error`);
    } finally {
      setShowSpinner(false)
    }
  }

  const getSubscriptionLinkDataWithSearchValue = async () => {
    const params = new URLSearchParams(search);
    if (!params.get('ss') || !params.get('secret')) {
      return;
    }
    setShowSpinner(true);
    try {
      const value = await findSubscriptionV2LinkById(id, search);
      if (value) {
        const { redirectUri } = value;
        setData(value);
        value.amount = value?.subscription2?.total ? value.subscription2.total : value?.subscription2?.amount;
        value.currency = value?.account?.currency;
        setPayment(value);
        setTransactionSuccessModalOpen(true);
        setApplePayment(value?.account?.supportedRecurringPaymentTypes.includes('APPLE_PAY_US'));
        if ((value?.account?.supportedRecurringPaymentTypes).includes('GOOGLE_PAY_US') || (value?.account?.supportedRecurringPaymentTypes).includes('WALLET')) {
          await getGooglePayMerchantValues(value && value.account && value.account.gid);
        }
        setTimeout(function () {
          const uri = getRedirectionUrl(hostName);
          if (redirectUri) {
            window.location = `${redirectUri}&sp-subscription-link=${id}`;
          } else if (uri) {
            window.location = `${uri}subscriptions/${subscriptionId}`;
          }
        }, 5000);
      }
    } catch (reason) {
      await getSubscriptionLinkDataWithoutSearchValue();
      error(reason);
    } finally {
      setShowSpinner(false);
    }
  };

  const setData = data => {
    if (data) {
      setSubscription(data.subscription2);
      setAccount(data.account);
      setSupportedPaymentTypes(data.account && data.account.supportedRecurringPaymentTypes);
      setBackButtonUrl(data.redirectUri || SWIREPAY_URL);
      setLink(data.link || SWIREPAY_URL);
    }
  };

  const error = reason => {
    setErrorMessage(null);
    const  message = reason && reason.message;
    setErrorMessage(message);
    setTransactionModalOpen(false);   
    const errorEl = document.getElementById("error");
    if (null !== errorEl) { errorEl.scrollIntoView(); }
  };

  const onSubmit = data => {
    let amount = currencyFormatter(1, subscription.currency && subscription.currency.name);
    setTransactionModalBodyText(`You will be redirected once verification is complete\n. As part of the verification, if using a debit or credit card you might see a temporary hold of ${amount}`)
    setTransactionModalOpen(true);
    addPaymentMethod(data)
  };

  const onAchPayment = data => {
    let amount = currencyFormatter(1, subscription.currency && subscription.currency.name);
    setTransactionModalBodyText(`You will be redirected once verification is complete\n. As part of the verification process, you might see a temporary hold of ${amount} in your bank account.`)
    setTransactionModalOpen(true);    
    addACHMethod(data)
  };

  const onGooglePay = data => {
    let amount = currencyFormatter(1, subscription.currency && subscription.currency.name);
    setTransactionModalBodyText(`You will be redirected once verification is complete\n. As part of the verification, if using a debit or credit card you might see a temporary hold of ${amount}`)
    setTransactionModalOpen(true);
    addGooglePayMethod(data);
  };

  const onApplePay = (devicedata, amount, customerName, customerEmail,
                customerPhone, countryCode, stateCode, street, postalCode, city,
                cardNetwork, cardType, cardLast4) => {
    let verifyAmount = currencyFormatter(1, subscription.currency && subscription.currency.name);
    setTransactionModalBodyText(`You will be redirected once verification is complete\n. As part of the verification, if using a debit or credit card you might see a temporary hold of ${verifyAmount}`)
    setTransactionModalOpen(true);
    addApplePayMethod(devicedata, amount, customerName, customerEmail,
                customerPhone, countryCode, stateCode, street, postalCode, city,
                cardNetwork, cardType, cardLast4);
  };

  const uniquePaymentTypes = supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
  if(uniquePaymentTypes.indexOf('APPLE_PAY_US') > -1) {
    uniquePaymentTypes.splice(uniquePaymentTypes.indexOf('APPLE_PAY_US'), 1);
  }
  const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
    let children;
    if (name === TabNames.ACH_LEGACY) {
      children = <AchPayment
        errorMsg={errorMessage}
        errorHeader={"Error occurred while processing the payment method."}
        customerReadOnly={false}
        submit={onAchPayment}
        preFillCustomer={subscription && subscription.customer}
        customerDisabled={false}
        headerText={null}
        buttonText={"Save Payment Method"}
        customerValidation={true}
        isBillingAdressRequired={(account && account.collectBillingAddress)}
        alpha2={subscription && subscription.currency && subscription.currency.countryAlpha2}
        plaidPublicToken={plaidPublicToken}
        setPlaidPublicToken={setPlaidPublicToken}
        accountGid={account?.gid}
        paymentLinkId={id}
      />
    } else if (name === TabNames.CARD) {
      children = <CardPayment
        errorMsg={errorMessage}
        errorHeader={"Error occurred while processing the payment method."}
        customerReadOnly={true}
        submit={onSubmit}
        preFillCustomer={subscription && subscription.customer}
        headerText={"ADD CARD"}
        buttonText={"Save Payment Method"}
        customerValidation={false}
        requiredPhone={false}
        isBillingAdressRequired={(account && account.collectBillingAddress)}
        alpha2={subscription && subscription.currency && subscription.currency.countryAlpha2}
      />
    } else if (name === TabNames.ACH) {
      children = <BankPayment
        errorMsg={errorMessage}
        errorHeader={"Error occurred while processing the payment method."}
        customerDisabled={false}
        submit={addBankMethod}
        preFillCustomer={subscription && subscription.customer}
        headerText={"Pay With Bank Transfer"}
        buttonText={"Save Payment Method"}
        iavUrl={`${BASE_URLS.SUBSCRIPTION_LINK}/${id}`}
        customerValidation={true}
        requiredPhone={false}
        alpha2={subscription && subscription.currency && subscription.currency.countryAlpha2}
      />
    } else if (name === TabNames.UPI) {
      children = <UpiPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={addUPIMethod}
        preFillCustomer={subscription && subscription.currency && subscription.currency.countryAlpha2}
        headerText={"Pay With UPI"}
        buttonText={"Save Payment Method"}
        customerValidation={true}
        alpha2={subscription && subscription.currency && subscription.currency.countryAlpha2}
      />
    } else if (name === TabNames.GOOGLE_PAY_US) {
      children = <GooglePay
          headerText={"PAY WITH GOOGLE PAY"}
          payment={payment}
          chargeByGooglePay={onGooglePay}
          gpaySecretValues={gpaySecretValues}
          gpayError={gpayError}
          errorMsg={errorMessage}
          errorHeader={null}
      />
    } else {
      children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
    }
    panel.push({ children });
    return panel;
  }, []) : [
    {
      children: <CardPayment
        errorMsg={errorMessage}
        errorHeader={"Error occurred while processing the payment method."}
        customerReadOnly={true}
        submit={onSubmit}
        preFillCustomer={subscription && subscription.customer}
        headerText={"ADD CARD"}
        buttonText={"Save Payment Method"}
        customerValidation={false}
        requiredPhone={false}
        isBillingAdressRequired={(account && account.collectBillingAddress)}
        alpha2={subscription && subscription.currency && subscription.currency.countryAlpha2}
      />
    }
  ];

  const tabPanelsApple =
      {
        children : applePayment&&isApplePay ?
            <Apple
                amount={payment && payment.amount}
                chargeByApple={onApplePay}
                payment={payment}
                subscriptionData={subscription}
                link={link}
            />
            : null
      }
  ;

  tabPanels.push(tabPanelsApple);

  return (
    <BaseSplitPage
    errorHeader={null}
    errorMsg={errorMessage}
    left={
      <>
        <FlexContainer
          flexDirection="column"
          position="relative"
          display="block"
          height="100%"
        >
          <div>
            <LeftBackButtonText
              onClick={() => { props.history.push(`/subscription2-link/${id}`); }}
            >
              Back
            </LeftBackButtonText>
            <H1Text>ADD PAYMENT METHOD</H1Text>
            <div hidden={!(subscription && subscription.description)}>
              <H2Text>Payment For</H2Text>
              <DescriptionText>
                {subscription && subscription.description}
              </DescriptionText>
            </div>
            <div hidden={!(subscription && subscription.planAmount)}>
              <H2Text>
                Amount Payable
              </H2Text>
              <DescriptionText>
                {subscription ? `${currencyFormatter(AmountDivideByHundred(subscription.total), subscription.currency && subscription.currency.name)}` : null}
              </DescriptionText>
            </div>
            <Text
              hidden={!(subscription && (subscription.totalSuccessfulPayments === 0) && (subscription.upfrontAmount !== 0))}
              fontSize="12px"
              marginBottom="20px"
              color="#6b6c6f"
              lineHeight="21px"
            >
              A one-time upfront charge of&nbsp;<span style={{ fontWeight: "600", color: "black" }}>
                {subscription && currencyFormatter(AmountDivideByHundred(subscription.upfrontAmount), subscription.currency && subscription.currency.name)}
              </span>&nbsp;will be added to the first payment.
            </Text>
            <div hidden={!(subscription && subscription.nextPaymentDate)}>
              <H2Text>
                NEXT PAYMENT DUE ON
              </H2Text>
              <DescriptionText>
                {subscription && subscription.nextPaymentDate && getformatteddate(subscription.nextPaymentDate, account && account.timezone)}
              </DescriptionText>
            </div>
          </div>
          <div style={{ position: "sticky", top: "85%" }}>
            <Support email={account && account.support && account.support.email}
              whiteLabel={account && account.whiteLabel}
              phone={account && account.support && account.support.phone} />
          </div>
        </FlexContainer>
      </>
    } right={
      <>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {
            payment?.plans && payment?.plans.map((item) => (
              <div style={{ width: '200px', textAlign: 'center', alignItems: 'center', marginTop: '10%', border: '1px solid #6D83A0', borderRadius: '10px', marginRight: '20px' }}>
                <div style={{ backgroundColor: `${item?.currentPlan ? '#6D83A0' : '#5A8CC2'}`, padding: '20px 0px', textAlign: 'center', alignItems: 'center', alignContent: 'center', borderRadius: '10px 10px 0px 0px' }}>
                  <Text
                    fontSize="20px"
                    color="#fff"
                    lineHeight="21px"
                    textAlign='center'
                  >{item?.name}</Text>
                </div>
                <div style={{ padding: '30px 10px', textAlign: 'center', alignItems: 'center', alignContent: 'center' }}>
                  <Text
                    fontSize="20px"
                    color="#000"
                    lineHeight="21px"
                    textAlign='center'
                  >{currencyFormatter(AmountDivideByHundred(item?.amount), subscription.currency && subscription.currency.name)}</Text>
                </div>
                <div style={{ padding: '10px 10px', textAlign: 'center', alignItems: 'center', alignContent: 'center' }}>
                  <Button type="primary"
                    borderRadius="50px"
                    border={`${item?.currentPlan ? '1px solid #00B412 !important' : '1px solid #4E9BF7 !important'}`}
                    className="px-3 py-2 mt-3"
                    backgroundColor={`${item?.currentPlan ? '#00B412 !important' : '#4E9BF7 !important'}`}
                    onClick={() => (item?.currentPlan ? null : (item?.status === 'ACTIVE' ? updatePlan(item?.gid) : null))}
                  >{item?.currentPlan ? 'Active' : 'Choose'}</Button>
                </div>
              </div>
            ))
          }
        </div>
        <TransactionModal
          header={"We are verifying your Plan"}
          body={transactionModalBodyText}
          isOpen={isTransactionModalOpen} />
        <SuccessModal isOpen={isTransactionSuccessModalOpen} message="New plan selected Successfully" pauseType="You will be redirected automatically." />
      </>
    } />
  )
};

export default PlanList
